import http from 'hub-http/clients/apiClient';
import HubHttpClient from 'ExportDialog/apiClients/HubHttpBaseClient';
import { ASSIGNMENTS_API } from '../playlistAssignments';
import { HUBLET_AWARE_SERVICE_URI } from '../../constants/ApiConstants';
export const ExportClient = (exportType, extraData = {}) => {
  return Object.assign({}, HubHttpClient, {
    export: settings => {
      let endpoint;
      switch (exportType) {
        case 'MY_TEAM':
          {
            endpoint = `${HUBLET_AWARE_SERVICE_URI}/v1/team/progress/export`;
            break;
          }
        case 'PLAYLIST_ASSIGNMENTS':
          {
            // TODO: export endpoint
            endpoint = `${ASSIGNMENTS_API}/export`;
            break;
          }
        default:
          return Promise.reject(new Error(`unexpected export type: ${exportType}`));
      }
      return http.post(endpoint, {
        data: Object.assign({}, extraData, settings)
      });
    }
  });
};